import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

// ✅ GET: Traer todos los viajes
export const getViajes = async () => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/viajes`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener comandas",
    };
  }
};

// ✅ GET: Traer un viaje por ID
export const getViajeById = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/viajes/${id}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return { ok: true, viaje: resp.data }; // ⬅️ esto lo esperaba tu código antes
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener viaje",
    };
  }
};


// ✅ POST: Crear nuevo viaje
export const postViaje = async (viajeData) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/viajes`;

  try {
    const res = await axios.post(url, viajeData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return res.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear viaje",
    };
  }
};


// ✅ PUT: Editar un viaje existente
export const putViaje = async (id, viajeData) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/viajes/${id}`;

  try {
    const res = await axios.put(url, viajeData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return res.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar viaje",
    };
  }
};

// ✅ DELETE: Eliminar un viaje
export const deleteViaje = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/viajes/${id}`;

  try {
    const res = await axios.delete(url, {
      headers: { token },
    });
    return res.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar viaje",
    };
  }
};

// helpers/rutaViajes.js
export const anularViaje = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/viajes/anular/${id}`;

  try {
    const res = await axios.put(url, {}, {
      headers: {
        token,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("❌ Error al anular viaje:", error);
    return {
      ok: false,
      error: error.response?.data || "Error al anular viaje",
    };
  }
};

// ✅ Dashboard combustible
export const getDashboardCombustible = async (filtros = {}) => {
  const token = localStorage.getItem("token") || "";
  const params = new URLSearchParams();

  if (filtros.desde) params.append("desde", filtros.desde);
  if (filtros.hasta) params.append("hasta", filtros.hasta);
  if (filtros.camionId) params.append("camionId", filtros.camionId);
  if (filtros.choferId) params.append("choferId", filtros.choferId);

  const query = params.toString();
  const url = `${BASE_URL}/viajes/dashboard-combustible${query ? `?${query}` : ""}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });

    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener dashboard de combustible",
    };
  }
};
